module.exports = __webpack_public_path__ + "static/media/ic-bookmark-border.fc564e73.svg";